import React from 'react';
import { useStateBus } from '~/state/bridge';
import { getCurrentAgent } from '~/state/Agents/selectors';

const AgentAlert = () => {
  const agent = useStateBus(getCurrentAgent);

  if (!agent) {
    return null;
  }

  return (
    <p className="agent-alert">
      {`Leads from this campaign will be assigned to: ${agent.name}`}
    </p>
  );
};

export default AgentAlert;
